import React from 'react'

const BuzzText = () => {
  return (
    <div className='buzztext'>• Free Courtesy Car• Friendly Service• Free MOT Re-Test!• Great Rates On Tyres• Keep Your Warranty• Great Discounts!</div>
  )
}

export default BuzzText